export enum CvAssessmentStatementType {
  STRENGTH = 1,
  RISK = 2,
  SUGGESTION = 3,
}

export enum CvAssessmentStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  COMPLETED = 20,
  FAILED = -20,
  LEGACY_FAILED = 30,
  RFP_NOT_EXHAUSTIVE = 40,
  BID_NOT_EXHAUSTIVE = 50,
}
